import { IGameSession, IGame, IGameProvider, ILobbySection, IGameActivity } from '@libs/interfaces';
export interface IGameState {
  grid_game_sessions: IGrigGameSession[];
  selectedIndex: number;
  categories: ILobbySection[];
  categorySearchGames: IGame[];
  gamesProviders: IGameProvider[];
  activity: IGameActivity[];
  fullscreen: boolean;
  game_screen_layout: GAME_SCREEN_LAYOUT;
  desktop: SCREEN_GRID_TYPE;
  game_type: GAME_TYPE;
  showGamesTree: boolean;
  game: IGame;
}

export enum GAME_TYPE {
  REAL = 'REAL',
  FUN = 'FUN',
}
export enum GAME_SCREEN_LAYOUT {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  QUADRUPLE = 'QUADRUPLE',
}
export enum SCREEN_GRID_TYPE {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  MOBILE_SMALL = 'MOBILE_SMALL',
}
export interface IGrigGameSession {
  session: Partial<IGameSession>;
  game: Partial<IGame>;
}
